import MuiButton from 'components/common/button/MuiButton';
import T from 'components/common/text/T';
import ProjectIndicationContainer from 'containers/project/ProjectIndicationContainer';
import { IProjectInfo, IRemake, IRework } from 'lib/types/projectTypes';
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ProjectInfo from './ProjectInfo';
import ProjectInfoFiles from './ProjectInfoFiles';

interface ProjectDetailProps {
  extraDesignOp: any;
  reworkListCt: {
    value: IRework[];
    onChange: (e: any) => void;
    setValue: (value: IRework[]) => void;
  };
  indicationFormat: object | any;
  indicationInfo: object | any;
  language: string;
  hasAlarm: any;
  projectInfo: IProjectInfo;
  isProjectCreator: boolean;
  managerList: object | any;
  remakeList: IRemake[];
  prevPartnerManager: number | null;
  partnerManager: {
    value: number;
    onChange: (e: any) => void;
    setValue: (value: number) => void;
  };
  onChangePartnerManager: (number: number) => void;
  onOpenReworkStatusModal: () => void;
}

function ProjectDetail({
  extraDesignOp,
  reworkListCt,
  indicationFormat,
  indicationInfo,
  language,
  hasAlarm,
  projectInfo,
  isProjectCreator,
  managerList,
  remakeList,
  prevPartnerManager,
  partnerManager,
  onChangePartnerManager,
  onOpenReworkStatusModal,
}: ProjectDetailProps) {
  const { pcode } = useParams() as { pcode: string };
  const history = useHistory();

  return (
    <Styled.ProjectDetail data-component-name="ProjectDetail">
      <div className="projectDetail__container">
        <div className="projectDetail__section1">
          <ProjectInfo
            extraDesignOp={extraDesignOp}
            reworkListCt={reworkListCt}
            indicationFormat={indicationFormat}
            indicationInfo={indicationInfo}
            language={language}
            hasAlarm={hasAlarm}
            projectInfo={projectInfo}
            isProjectCreator={isProjectCreator}
            managerList={managerList}
            remakeList={remakeList}
            prevPartnerManager={prevPartnerManager}
            partnerManager={partnerManager}
            onChangePartnerManager={onChangePartnerManager}
            onOpenReworkStatusModal={onOpenReworkStatusModal}
          />
        </div>
        <div className="projectDetail__section2">
          <ProjectIndicationContainer
            projectInfo={projectInfo}
            isProjectCreator={isProjectCreator}
          />
        </div>
        <div className="projectDetail__section3">
          <ProjectInfoFiles />
        </div>
      </div>

      {/* {isProjectCreator && (
      )} */}
      <div className="project__modify_button">
        <MuiButton
          config={{
            width: '275px',
          }}
          disableElevation
          variant="contained"
          className="project__modify"
          onClick={() => history.push(`/project/edit/${pcode}`)}
        >
          <T>GLOBAL_MODIFY</T>
        </MuiButton>
      </div>
    </Styled.ProjectDetail>
  );
}

export default React.memo(ProjectDetail);

const Styled = {
  ProjectDetail: styled.section<{}>`
    position: relative;
    background-color: #fff;
    .projectDetail__container {
      display: flex;
      position: relative;
      margin: 30px;
      height: 650px;
      .projectDetail__section1 {
        height: 650px;
        width: 480px;
        margin-right: 90px;
      }
      .projectDetail__section2 {
        height: 650px;
        width: calc(100% - 570px);
      }
      .projectDetail__section3 {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 480px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
      }
    }
    .project__modify_button {
      position: absolute;
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 20px;
    }
  `,
};
